var FilesGridItemComponent = /** @class */ (function () {
    function FilesGridItemComponent() {
        this.driveEntry = true;
    }
    Object.defineProperty(FilesGridItemComponent.prototype, "fileId", {
        get: function () {
            return this.entry.id;
        },
        enumerable: true,
        configurable: true
    });
    return FilesGridItemComponent;
}());
export { FilesGridItemComponent };
